import React, { Fragment, FunctionComponent, useEffect, useState } from 'react';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import {
  Cell,
  Row,
  downloadSheets,
  generateSheet,
  printDataAsTable,
  SheetHeaderDisplay,
} from '../../../utils';
import {
  Dropdown,
  DropdownButton,
  Row as BSRow,
  Table,
} from 'react-bootstrap';
import { AuthedLayout } from '../../../components';
import { useSemGrade } from '../../../hook';
import apis from '../../../apis';
import { CompareYearClassSightRate, UserInfo } from '../../../model';
import { toast } from 'react-toastify';

const borderStyle = { color: { rgb: '000000' }, style: 'thin' } as const;
const bottomBorderStyle = {
  bottom: borderStyle,
};
const topBottomBorderStyle = {
  top: borderStyle,
  bottom: borderStyle,
};
const fullBorderStyle = {
  top: borderStyle,
  bottom: borderStyle,
  left: borderStyle,
  right: borderStyle,
} as const;
const cellAlignStyle = {
  horizontal: 'center',
  vertical: 'center',
} as const;

const mapState = (state: ApplicationState) => ({ ...state.auth });
const mapDispatches = ErrorDispatches;

const connector = connect(mapState, mapDispatches);

type Props = ConnectedProps<typeof connector>;

const sightDeteriorateRate: FunctionComponent<Props> = ({ catchErrorForModal }) => {
  const { yearSem, element } = useSemGrade();
  const [datas, setDatas] = useState<CompareYearClassSightRate[]>([]);
  const [userinfo, setUser] = useState<UserInfo>();
  useEffect(() => {
    if (yearSem) {
      toast
        .promise(
          apis.getSightDeteriorateRate(yearSem.year, yearSem.sem)
            .then((s) =>
              setDatas(s)

            ),
          {
            pending: '資料載入中......',
            success: '資料載入成功！',
            error: '資料載入失敗！請查看錯誤資訊。',
          }
        )
      apis.getUserInfo()
        .then((u) => {
          setUser(u);
        })
        .catch(catchErrorForModal);

    }
  }, [yearSem?.year, yearSem?.sem]);
  const validDatas = datas.filter(x => Number(x.lastYearCount) !== 0);
  let schoolYearfailtP = 0;
  const contentRows: Row[] = validDatas.flatMap(
    (gs, idx, allArray) => {
      if (Number(gs.lastYearCount) === 0) return [];
      gs.lastYearFailtP = percent(Number(gs.lastYearFailt), Number(gs.lastYearCount));
      gs.thisYearFailtP = percent(Number(gs.thisYearFailt), Number(gs.thisYearCount));
      gs.failtGAP = ((Number(gs.thisYearFailt) / Number(gs.thisYearCount)) - (Number(gs.lastYearFailt) / Number(gs.lastYearCount)));
      if (gs.failtGAP != null) {
        schoolYearfailtP = schoolYearfailtP + Number(gs.failtGAP);
      }
      return sightToRow(
        gs.thisGrade,
        gs.thisYearCount,
        gs.thisYearFailt,
        gs.thisYearFailtP,
        gs.lastGrade,
        gs.lastYearCount,
        gs.lastYearFailt,
        gs.lastYearFailtP,
        gs.failtGAP
      )
    }
  );

  const content: Row[] = [
    {
      cells: [
        {
          value: '本學年度',
          merge: { column: 4 },
          style: { border: { top: borderStyle, left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
        },
        {
          value: '上學年度',
          merge: { column: 4 },
          style: { border: { top: borderStyle, left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
        },
        {
          value: '',
          merge: { column: 1 },
          style: { border: { top: borderStyle, left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
        }
      ]
    },
    {
      cells: [
        {
          value: '年級',
          merge: { column: 1 },
          style: { border: { left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
        },
        {
          value: '視力受檢人數A',
          merge: { column: 1 },
          style: { border: { left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
        },
        {
          value: '裸眼視力不良人數B',
          merge: { column: 1 },
          style: { border: { left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
        },
        {
          value: '裸眼視力不良率C',
          merge: { column: 1 },
          style: { border: { left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
        },
        {
          value: '年級',
          merge: { column: 1 },
          style: { border: { left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
        },
        {
          value: '視力受檢人數A',
          merge: { column: 1 },
          style: { border: { left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
        },
        {
          value: '裸眼視力不良人數B',
          merge: { column: 1 },
          style: { border: { left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
        },
        {
          value: '裸眼視力不良率C',
          merge: { column: 1 },
          style: { border: { left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
        },
        {
          value: '裸視篩檢視力不良惡化率D',
          merge: { column: 1 },
          style: { border: { left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
        },
      ],
    },
    ...contentRows,
    {
      cells: [
        {
          value: '平均',
          merge: { column: 8 },
          style: { border: { left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
        },
        {
          value: ((schoolYearfailtP / validDatas.length) * 100).toFixed(2) + "%",
          merge: { column: 1 },
          style: { border: { left: borderStyle, right: borderStyle }, alignment: { horizontal: 'left' } },
        },
      ],
    },
  ];
  type PrintRow = {
    thisGrade: number | string;
    thisYearCount: number | string;
    thisYearFailt: number | string;
    thisYearFailtP: string;
    lastGrade: number | string;
    lastYearCount: number | string;
    lastYearFailt: number | string;
    lastYearFailtP: string;
    failtGAP: string;
  };

  const printHeaders: SheetHeaderDisplay<PrintRow>[] = [
    {
      display: '本學年度-年級',
      property: 'thisGrade',
    },
    {
      display: '本學年度-視力受檢人數A',
      property: 'thisYearCount',
    },
    {
      display: '本學年度-裸眼視力不良人數B',
      property: 'thisYearFailt',
    },
    {
      display: '本學年度-裸眼視力不良率C',
      property: 'thisYearFailtP',
    },
    {
      display: '上學年度-年級',
      property: 'lastGrade',
    },
    {
      display: '上學年度-視力受檢人數A',
      property: 'lastYearCount',
    },
    {
      display: '上學年度-裸眼視力不良人數B',
      property: 'lastYearFailt',
    },
    {
      display: '上學年度-裸眼視力不良率C',
      property: 'lastYearFailtP',
    },
    {
      display: '裸視篩檢視力不良惡化率D',
      property: 'failtGAP',
    },
  ];

  const printRows: PrintRow[] = validDatas.map((gs) => {
    const thisYearFailtP = percent(
      Number(gs.thisYearFailt),
      Number(gs.thisYearCount)
    );

    const lastYearFailtP = percent(
      Number(gs.lastYearFailt),
      Number(gs.lastYearCount)
    );

    const failtGAP =
      Number(gs.thisYearFailt) / Number(gs.thisYearCount) -
      Number(gs.lastYearFailt) / Number(gs.lastYearCount);

    return {
      thisGrade: gs.thisGrade,
      thisYearCount: gs.thisYearCount,
      thisYearFailt: gs.thisYearFailt,
      thisYearFailtP: `${thisYearFailtP}%`,

      lastGrade: gs.lastGrade,
      lastYearCount: gs.lastYearCount,
      lastYearFailt: gs.lastYearFailt,
      lastYearFailtP: `${lastYearFailtP}%`,

      failtGAP: `${(failtGAP * 100).toFixed(2)}%`,
    };
  });

  const averageRate =
    validDatas.length > 0
      ? `${((schoolYearfailtP / validDatas.length) * 100).toFixed(2)}%`
      : '0.00%';

  printRows.push({
    thisGrade: '平均',
    thisYearCount: '',
    thisYearFailt: '',
    thisYearFailtP: '',
    lastGrade: '',
    lastYearCount: '',
    lastYearFailt: '',
    lastYearFailtP: '',
    failtGAP: averageRate,
  });

  return (
    <AuthedLayout>
      <BSRow className="justify-content-between">
        <span className="mr-3">{element}</span>
        <DropdownButton
          id="sight-deteriorate-rate-export"
          title="匯出"
          variant="success"
          disabled={!validDatas.length}
        >
          <Dropdown.Item
            onClick={() => {
              const workSheet = generateSheet(
                [
                  {
                    cells: [
                      {
                        value:
                          `${yearSem?.year}學年第` +
                          `${yearSem?.sem}學期_裸視篩檢視力不良惡化率`,
                        style: {
                          alignment: {
                            horizontal: 'left',
                          },
                        },
                      },
                    ],
                  },
                  ...content,
                  {
                    cells: [
                      {
                        value:
                          '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
                        style: {
                          alignment: {
                            horizontal: 'left',
                          },
                        },
                      },
                    ],
                  },
                ],
                {
                  alignment: cellAlignStyle,
                }
              );

              downloadSheets(
                `${yearSem?.year}學年第${yearSem?.sem}學期_裸視篩檢視力不良惡化率`,
                userinfo?.exportFileType,
                {
                  sheet: workSheet,
                  name: 'SightMatrix',
                }
              );
            }}
          >
            Excel 下載
          </Dropdown.Item>

          <Dropdown.Item
            onClick={() => {
              printDataAsTable({
                title:
                  `${yearSem?.year}學年第` +
                  `${yearSem?.sem}學期_裸視篩檢視力不良惡化率`,
                values: printRows,
                headers: printHeaders,
                footer:
                  '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
              });
            }}
          >
            列印
          </Dropdown.Item>
        </DropdownButton>
      </BSRow>
      <hr />
      <BSRow>
        <Table
          striped
          bordered
          className="text-center"
          style={{ tableLayout: 'fixed' }}
        >
          <colgroup>
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
            <col style={{ width: '7%' }} />
          </colgroup>
          <tbody>
            {content.map((r, i) => {
              const cells = r.cells.map((c, j) =>
                c.value != undefined ? (
                  <td
                    colSpan={c.merge?.column}
                    rowSpan={c.merge?.row}
                    key={`${i}-${j}`}
                  >
                    {c.value}
                  </td>
                ) : (
                  <Fragment key={`${i}-${j}`}></Fragment>
                )
              );
              return <tr key={i}>{cells}</tr>;
            })}
          </tbody>
        </Table>
      </BSRow>
    </AuthedLayout>
  );

};

function sightToRow(
  thisgrade: number,
  thisyearcount: number,
  thisyearfailt: number,
  thisyearfailtP: number,
  lastgrade: number,
  lastyearcount: number,
  lastyearfailt: number,
  lastyearfailtP: number,
  failtGAP: number
): Row[] {
  return [
    {
      cells: [
        {
          value: thisgrade,
          style: { border: bottomBorderStyle },
        }, {
          value: thisyearcount,
          style: { border: bottomBorderStyle },
        }, {
          value: thisyearfailt,
          style: { border: bottomBorderStyle },
        },
        {
          value: thisyearfailtP + "%",
          style: { border: bottomBorderStyle },
        }, {
          value: lastgrade,
          style: { border: bottomBorderStyle },
        }, {
          value: lastyearcount,
          style: { border: bottomBorderStyle },
        }, {
          value: lastyearfailt,
          style: { border: bottomBorderStyle },
        },
        {
          value: lastyearfailtP + "%",
          style: { border: bottomBorderStyle },
        },
        {
          value: (failtGAP * 100).toFixed(2) + "%",
          style: { border: bottomBorderStyle },
        }
      ]
    }
  ];
}
function percent(value: number, denominator: number): number {
  if (!denominator) return 0.00;
  return Number(((value / denominator) * 100).toFixed(2));
}


export const SightDeteriorateRate = connector(sightDeteriorateRate);